import { Component, Input } from '@angular/core';

import { BuildingBlockInterface } from '../building-block.interface';
import { SubheadingComponentContext } from './subheading-context.interface';

@Component({
    selector: 'app-subheading',
    templateUrl: './subheading.component.html',
    styleUrls: ['./subheading.component.min.css'],
})
export class SubheadingComponent implements BuildingBlockInterface {
    @Input() public context: SubheadingComponentContext;
    public paddingEnabled = true;
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/building-blocks/subheading/subheading.component.ts